import axios from 'axios';
class AnalyticsApiService {
    constructor({ domain, accessTokenGetter, isAuthenticated }) {
        this.analyticsApiHost = domain;
        this.accessTokenGetter = accessTokenGetter;
        this.isAuthenticated = isAuthenticated;
    }
    async api() {
        const accessToken = await this.accessTokenGetter();
        return axios.create({
            baseURL: `${this.analyticsApiHost}/v1`,
            timeout: 20000,
            headers: {
                authorization: `Bearer ${accessToken}`,
            },
        });
    }
    async sendEventToAnalyticsApi(payload) {
        const api = await this.api();
        await api.post('/analytics/track-event', payload);
    }
}
export default AnalyticsApiService;
//# sourceMappingURL=analyticsApi.service.js.map